import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import Photo from "../components/portfolio/Photo"

import LandscapesPhoto from "../images/landscapes.webp"
import PortraitsPhoto from "../images/portraits.webp"
import StudioPhoto from "../images/studio.webp"

const photos = [
  {
    img: LandscapesPhoto,
    title: "Landscapes",
    projectNumber: 2,
    photos: 12,
    description:
      "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur",
  },
  {
    img: PortraitsPhoto,
    title: "Portraits",
    projectNumber: 12,
    photos: 69,
  },
  {
    img: StudioPhoto,
    title: "Studio",
    projectNumber: 3,
    photos: 172,
  },
]

const SecondPage = () => (
  <Layout>
    <Seo title="Portfolio" />
    <div className="desktop pb-[80px]">
      {photos.map(photo => (
        <Photo {...photo} key={photo.title} />
      ))}
    </div>
  </Layout>
)

export default SecondPage
